import { Component, OnInit, HostBinding, ViewChild, ElementRef, Output, EventEmitter } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import * as _ from "underscore";


import { AppComponent } from "./../../app.component";
import {
  BASE_URI,
  path,
  config,
  AlertPopup,
  HttpLoader,
} from "./../../app.config";
import { ValidationService } from "./../form-validation/validation.service";
import { UserService } from "./../userandgroup/user/user.service";
import { SettingsService } from "./settings.service";
import { UtilityService } from "./../../utility.service";
import { HeaderService } from "./../header/header.service";
import { FileValidationService } from "./../../shared/file-validation.service";
import { MustMatch } from "./must-match.validator";
import { ConfirmationDialogService } from "app/confirmation-dialog/confirmation-dialog.service";
import { ThemeService } from './theme.service';
import { finalize } from "rxjs";
// import { EventEmitter } from 'protractor';




// @Directive()
@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
  standalone: false
})
export class SettingsComponent implements OnInit {
  @HostBinding("class.flex-grid") leftBarClass = true;
  @HostBinding("style.width") flexwidth = "100%";
  @HostBinding('style.flex-direction') direction = 'column';
  @ViewChild("fileInput") fileInput!: ElementRef;
  @ViewChild("logoFileInput") logoFileInput!: ElementRef;
  @Output() onClose = new EventEmitter();
  @ViewChild("closebutton") closebutton!: ElementRef;




  newUserForm: FormGroup;
  accountFrom: FormGroup;
  settingsForm: FormGroup;
  instituteForm: FormGroup;


  submitted = false;
  // selectedFileList: any[] = [];
  settingsDetail: any = {};
  _cloneSettingsDetail: any = {};
  chat_layout: any = {};
  settingsList: any[] = [];
  otherSettings: any = {};
  fileLoadedPercentage: number = 0;
  logged_user_id: number = 0;
  user_icon: any = "";
  company_icon: string = "";
  tabName = "profile";
  layoutShow = false;
  showIconImage = false;
  showBtnSpinner = false;
  loggedUserRole: number = 0

  cuntryCode: number = 0;

  genderArrayList = [
    { name: "Male", value: "M" },
    { name: "Female", value: "F" },
    // {name: 'Other',value: 'O'}
  ];

  defaultGender = "M";

  /** User Profile icon handler variables */
  selectedFileList: any[] = [];
  selectedLogoFileList: any[] = [];
  profileExtension = config.PROFILE_EXT;
  profileSize = config.PROFILE_SIZE;

  profileUrl = path.PROFILE_URL;
  companyUrl = path.COMPANY_URL;

  preUploadedFile: any;
  selectedTheme: any = "steelblue";
  layoutForm: FormGroup = new FormGroup({});
  themeForm: FormGroup = new FormGroup({});
  aiModelForm: FormGroup = new FormGroup({});
  constructor(
    private appComponent: AppComponent,
    private fb: FormBuilder,
    private alert: AlertPopup,
    private httpLoader: HttpLoader,
    private userService: UserService,
    private settingsService: SettingsService,
    private http: HttpClient,
    private router: Router,
    private utilityService: UtilityService,
    private headerService: HeaderService,
    private themeService: ThemeService,
    private confirmDialogService: ConfirmationDialogService,
    private fileValidationService: FileValidationService,
  ) {
    this.newUserForm = fb.group({
      first_name: [
        null,
        Validators.compose([
          Validators.required,
          ValidationService.namePattern,
        ]),
      ],
      last_name: [""],
      email_id: [
        "",
        Validators.compose([
          Validators.required,
          ValidationService.emailValidator,
        ]),
      ],
      phone_no: ['', Validators.compose([
        Validators.required,
        ValidationService.phoneNoValidate,
        ValidationService.noWhitespaceValidator
      ])],
      user_address: [""],
      user_city: [""],
      user_state: [""],
      user_zip: [null],
      gender: [""],
      user_notes: [""],
    });




    //   this.accountFrom = fb.group({
    //     old_password: ['', Validators.compose([Validators.required, ValidationService.passwordValidator])],
    //     new_password: ['', Validators.compose([Validators.required, ValidationService.passwordValidator])],
    //     confirm_password: ['', Validators.compose([Validators.required, ValidationService.passwordValidator])],
    //   }, {
    //     validator: MustMatch('new_password', 'confirm_password')
    // })




    this.accountFrom = fb.group(
      {
        old_password: ["", Validators.compose([Validators.required, ValidationService.passwordValidator])],
        new_password: [
          "",
          Validators.compose([Validators.required, ValidationService.passwordValidator]),
        ],
        confirm_password: ["", Validators.compose([Validators.required, ValidationService.passwordValidator])],
      },
      {
        validator: MustMatch("new_password", "confirm_password"),
      }
    );




    this.instituteForm = fb.group({
      title: ['', Validators.compose([Validators.required, ValidationService.noWhiteSpaceTitleValidator])],
      caption: ['', Validators.compose([Validators.required, ValidationService.noWhiteSpaceTitleValidator])]
    });

    this.layoutForm = this.fb.group({
      'layout': ['', Validators.required]
    });

    this.themeForm = this.fb.group({
      theme: ['steelblue']
    });

    this.aiModelForm = this.fb.group({
      searchmodel: ['private', [Validators.required]]
    });
  }





  ngOnInit(): void {
    this.loggedUserRole = JSON.parse(
      window.localStorage.getItem('user_role') ?? 'null'
    );

    this.onClose.emit();

    this.httpLoader.showLoader();

    this.settingsService.getUserSettings().subscribe({
      next: (settings: any) => {
        this.layoutShow = true;

        this.httpLoader.hideLoader();

        this.logged_user_id = settings.loggedId;
        this.chat_layout = settings.chat_layout;

        // Set the selected layout
        this.layoutForm.patchValue({
          layout: this.chat_layout?.default_layout
            ? 'default_layout'
            : 'chat_layout'
        });

        // User settings
        this.user_icon = settings.userDetail?.user_icon;
        this.otherSettings = settings.otherSettings;
        this._cloneSettingsDetail = settings.settingsDetail;
        this.settingsDetail = { ...settings.settingsDetail };
        this.settingsList = settings.settingsList;

        // Patch user form
        if (settings.userDetail) {
          this.newUserForm.patchValue(settings.userDetail);
        }

        // Patch company/institute form
        const companyDetails = settings.company_details;

        if (companyDetails) {
          this.preUploadedFile = companyDetails;
          this.instituteForm.patchValue(companyDetails);
        } else {
          this.preUploadedFile = null;
        }
      },

      error: (error: unknown) => {
        this.httpLoader.hideLoader();
        console.error('Failed to load user settings:', error);
      },

      complete: () => {
        // API request completed successfully
      }
    });

    // Hide the loader on both success and error.
    // See the RxJS finalize() version below for the recommended implementation.
  }





  hasError($event: any) { }




  getPhoneNumber($event: any) { }




  telInputObject(obj: any) {
    console.log(obj.s.dialCode);
    this.cuntryCode = obj.s.dialCode;




    obj.setCountry("in");
  }




  onCountryChange($event: any) {
    console.log($event);
  }




  public isValidChar(evt: any) {
    evt = evt ? evt : event;
    var charCode = evt.charCode
      ? evt.charCode
      : evt.keyCode
        ? evt.keyCode
        : evt.which
          ? evt.which
          : 0;
    if (
      charCode > 31 &&
      (charCode < 65 || charCode > 90) &&
      (charCode < 97 || charCode > 122)
    ) {
      this.alert.showAlertMessage({
        message: "Please enter last Name in characters only.",
      });
      return false;
    }
    return true;
  }




  public isLettersOnly(evt: any) {
    evt = evt ? evt : event;
    var charCode = evt.charCode
      ? evt.charCode
      : evt.keyCode
        ? evt.keyCode
        : evt.which
          ? evt.which
          : 0;
    if (
      charCode > 31 &&
      (charCode < 65 || charCode > 90) &&
      (charCode < 97 || charCode > 122)
    ) {
      this.alert.showAlertMessage({
        message: "Please enter state in characters only.",
      });
      return false;
    }
    return true;
  }




  public isNumberKey(evt: any) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      // this.discountValidate = true;
      this.alert.showAlertMessage({
        message: "Please enter zip in numbers only",
      });
      // this.priceErrMsg = 'Please enter discount number only. For example 535';
      return false;
    } else {
      // this.discountValidate = false;
      return;
    }
  }




  /**
   * Update user details
   * @param userVal
   */
  updateUserDetail(userVal: any): void {
    this.httpLoader.showLoader();
    this.showBtnSpinner = true;

    this.userService.updateUserDetail(0, userVal)
      .pipe(
        finalize(() => {
          this.showBtnSpinner = false;
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (user) => {
          this.newUserForm.markAsPristine();
          this.alert.showAlertMessage(user);
        },
        error: (error) => {
          this.alert.showErrorMessage(
            error?.error?.message || 'Unable to update user details. Please try again.'
          );
        }
      });
  }




  /**
   * Update user own password
   * @param password
   */




  get f() {
    return this.accountFrom.controls;
  }

  updateAccountPassword(password: any): void {
    this.submitted = true;

    if (this.accountFrom.invalid) {
      this.accountFrom.markAllAsTouched();
      return;
    }

    this.httpLoader.showLoader();

    this.settingsService
      .updateOwnPassword(password)
      .pipe(
        finalize(() => this.httpLoader.hideLoader())
      )
      .subscribe({
        next: (response: any) => {

          console.log(response, 'response');


          this.submitted = false;

          this.accountFrom.reset();

          this.alert.showAlertMessage(response);

          this.router.navigate(['/login']);
        },
        error: (error: any) => {

          console.log(error?.message, 'error message');


          this.alert.showErrorMessage(
            error?.error.message || error?.error || 'Unable to update password. Please try again.'
          );
        }
      });
  }



  /**
   * De activate the user account (only soft delete)
   */
  deactivateUserAccount(value?: any): void {
    this.confirmDialogService.openConfirmDialog('', {
      title: 'Confirmation',
      message: 'Are you sure you want to deactivate your account?',
      btnOkText: 'YES',
      btnCancelText: 'NO',

      onClose: (confirmed: boolean) => {
        if (!confirmed) {
          return;
        }

        this.httpLoader.showLoader();

        this.settingsService.deleteAccount()
          .pipe(
            finalize(() => {
              this.httpLoader.hideLoader();
            })
          )
          .subscribe({
            next: (response) => {
              this.alert.showAlertMessage(response);

              window.localStorage.clear();

              this.router.navigate(['/login']);
            },
            error: (error) => {
              this.alert.showErrorMessage(
                error?.error?.message ||
                'Unable to deactivate your account. Please try again.'
              );
            }
          });
      }
    });
  }




  /**
   * Trigger file input click
   */
  triggerFileInput() {
    if (this.fileInput && this.fileInput.nativeElement && this.selectedFileList.length === 0) {
      this.fileInput.nativeElement.click();
    }
  }


  /**
   * Get file data and call file upload API
   * @param event
   */




  async onFileChange(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const files:any = input.files;

    if (!files?.length) {
      return;
    }

    const selectedFile = files[0];

    const formFields = {
      fieldName: 'user_profile',
      activity: 'user_profile_update',
      user_id: this.logged_user_id
    };

    try {
      // Validate selected file
      await this.fileValidationService.fileValidation(
        files,
        this.profileExtension,
        this.profileSize
      );

      // Upload profile image
      const response: any = await this.appComponent.fileUploadWithProgess(
        formFields,
        [selectedFile]
      );

      // Update profile image
      if (response && typeof response === 'object') {
        for (const item of Object.values(response) as any[]) {
          if (item?.user_icon) {
            this.user_icon = item.user_icon;

            this.headerService.userProfileChanged(item.user_icon);
            break;
          }
        }
      }

    } catch (error: any) {

      // Handle validation errors
      if (Array.isArray(error)) {
        error.forEach((message: string) => {
          this.alert.showErrorMessage(message);
        });
      } else {
        this.alert.showErrorMessage(
          error?.error?.message ||
          error?.message ||
          'Unable to upload profile image. Please try again.'
        );
      }

    } finally {
      // Clear selected file
      this.selectedFileList = [];
      input.value = '';
    }
  }




  async onLogoImgChange(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const files:any = input.files;

    if (!files?.length) {
      return;
    }

    const formFields = {
      fieldName: 'company_profile',
      activity: 'company_logo'
    };

    const selectedFile = files[0];

    try {
      // Validate logo file
      await this.fileValidationService.fileValidation(
        files,
        this.profileExtension,
        this.profileSize
      );

      // Upload company logo
      const response: any = await this.appComponent.fileUploadWithProgess(
        formFields,
        [selectedFile]
      );

      const uploadData = response?.[0];

      if (!uploadData) {
        throw new Error('Logo upload failed. Please try again.');
      }

      // Update uploaded logo
      if (uploadData.company_logo) {
        this.preUploadedFile = uploadData.company_logo;

        // Update institute details if form is valid
        if (this.instituteForm.valid) {
          this.updateInstituteData(this.instituteForm.value);
        }

        this.instituteForm.markAsDirty();

        // Enable disabled button
        document
          .querySelector<HTMLButtonElement>('.disabledBtn')
          ?.removeAttribute('disabled');
      }

      // Success message
      if (uploadData.message) {
        this.alert.showAlertMessage(uploadData.message);
      }

    } catch (error: any) {

      // Validation errors
      if (Array.isArray(error)) {
        error.forEach((message: string) => {
          this.alert.showErrorMessage(message);
        });
      } else {
        this.alert.showErrorMessage(
          error?.error?.message ||
          error?.message ||
          'File not supported. Only PNG, JPG and JPEG files are allowed.'
        );
      }

    } finally {
      // Reset selected files
      this.selectedLogoFileList = [];
      input.value = '';
    }
  }


  updateInstituteData(formData: any): void {

    if (!formData) {
      return;
    }

    const payLoad = {
      company_logo: this.preUploadedFile?.company_logo ?? null,
      title: String(formData.title ?? '').trim(),
      caption: String(formData.caption ?? '').trim()
    };

    this.showBtnSpinner = true;
    this.httpLoader.showLoader();

    this.settingsService.createInstituteDetails(payLoad)
      .pipe(
        finalize(() => {
          this.showBtnSpinner = false;
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {

          if (response?.success) {
            this.alert.showAlertMessage(response);

            this.headerService.instituteLogoChanged(response.data);

            this.instituteForm.markAsPristine();
          } else {
            this.alert.showErrorMessage(
              response?.message || 'Unable to update institute details.'
            );
          }

        },
        error: (error) => {
          this.alert.showErrorMessage(
            error?.error?.message ||
            'Unable to update institute details. Please try again.'
          );
        }
      });
  }

  deleteInstituteLogoIcon(): void {
    this.selectedLogoFileList = [];

    this.httpLoader.showLoader();

    this.userService.deleteCompanyLogo()
      .pipe(
        finalize(() => {
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {

          if (response?.success) {
            this.alert.showAlertMessage(response);

            // Clear uploaded logo
            this.preUploadedFile = null;

            // Get current institute form values
            const { title, caption } = this.instituteForm.getRawValue();

            // Update header logo
            this.headerService.instituteLogoChanged({
              company_logo: null,
              title,
              caption
            });

            // Update form state
            this.instituteForm.markAsPristine();
          } else {
            this.alert.showErrorMessage(
              response?.message || 'Unable to delete company logo.'
            );
          }
        },

        error: (error: any) => {
          this.alert.showErrorMessage(
            error?.error?.message ||
            'Failed to delete company logo. Please try again.'
          );
        }
      });
  }

  /**
   * Change the chat layout style or update notification settings
   * @param value - event for layout or settingsDetail for notifications
   * @param layout - layout type (optional)
   * @param form - form reference (optional)
   */
  updateUserSettings(value: any, layout?: any, form?: any): void {
    // Check whether this is a layout update
    const isLayoutUpdate = !!value?.target &&
      value.target.value !== undefined;

    let payload: any;

    if (isLayoutUpdate) {
      const isDefaultLayout = value.target.value === 'default_layout';

      payload = {
        default_layout: isDefaultLayout,
        grid_layout: 'Z_list-layout.png',
        list_layout: 'F_list_layout.png'
      };
    } else {
      // Notification settings update
      payload = value;
    }

    this.httpLoader.showLoader();

    this.settingsService.updateUserSettings(payload)
      .pipe(
        finalize(() => {
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {

          if (isLayoutUpdate) {
            // Update application layout settings
            this.appComponent.userSetting = {
              ...this.appComponent.userSetting,
              ...payload
            };

          } else {
            // Update notification settings clone
            this._cloneSettingsDetail = {
              ...this.settingsDetail
            };

            // Reset form dirty state
            form?.markAsPristine();
          }

          this.alert.showAlertMessage(response);
        },

        error: (error: any) => {
          this.alert.showErrorMessage(
            error?.error?.message ||
            'Unable to update user settings. Please try again.'
          );
        }
      });
  }

  deleteUserProfileIcon(): void {
    this.selectedFileList = [];

    // Reset file input
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }

    this.httpLoader.showLoader();

    this.userService.deleteUserProfile(this.logged_user_id)
      .pipe(
        finalize(() => {
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {

          if (response?.success) {
            this.user_icon = null;

            // Update header profile image
            this.headerService.userProfileChanged(null);

            this.alert.showAlertMessage(response);
          } else {
            this.alert.showErrorMessage(
              response?.message || 'Unable to delete profile image.'
            );
          }
        },

        error: (error: any) => {
          this.alert.showErrorMessage(
            error?.error?.message ||
            'Failed to delete profile image. Please try again.'
          );
        }
      });
  }

  /**
   * Navigate tab from settings menu
   * @param tabName
   */
  selectSettingsTab(tabName: string) {
    if (tabName === "notification") {
      this.settingsDetail = { ...this._cloneSettingsDetail };
    }
    this.tabName = tabName;


  }

  settingChange(field_name: any, bool: any) {


    if (field_name === "do_not_disturb" && bool) {
      for (const key in this.settingsDetail) {
        if (key) {
          this.settingsDetail[key] = false;
        }
      }
    }

    if (field_name === "do_not_disturb" && !bool) {
      this.settingsDetail = { ...this._cloneSettingsDetail };
    }
  }




  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }




  /**
   * NgFor track by function
   * @param index
   * @param item
   */
  trackByFn(index: any, item: any) {
    return index;
  }


  showProfileImage() {
    this.showIconImage = true;
  }

  hideIconImage() {
    this.showIconImage = false;
    this.onClose.emit(false);
  }


  outsideClickIcon() {
    this.showIconImage = false;
  }
  onRadioChange(event: any) {
    this.selectedTheme = event.target.value;
    this.themeService.setTheme(this.selectedTheme);
    this.alert.showAlertMessage({
      message: "Theme Changed.",
    });
  }

  onModelChange(event: any) {

  }

}
